import React, { useEffect, useState } from 'react'
import '../../../styles/training.css'
import GetDataSet from '../../../services/data'
import IonIcon from '@reacticons/ionicons'
import InfoIconWithToolTip from '../../../util/tooltipwrapper'
import { useSubscription } from '../../../context/subscriptionprovider'
import { useStoreId } from '../../../hooks/geturlstoreid'

const Sidebar = ({ active, setActive }) => {
  const [Counts, setCounts] = useState({
    chatbot: 0,
    article: 0,
    faq: 0,
    unmatched: 0
  })
  const [previewActive, setPreviewActive] = useState(false)
  const store_id = useStoreId()
  const { isRestricted, activePlan, limitedPermission } = useSubscription()
  const isAccessRestricted =
    isRestricted ||
    !limitedPermission ||
    limitedPermission.custom_dataset_training === false

  const handleItemClick = id => {
    setActive(id)
  }

  const chatbot = localStorage.getItem('chatbot') || 'Chatbot' // Default value if localStorage is null

  // Set default active item based on localStorage
  useEffect(() => {
    if (chatbot === 'shopify') {
      setActive(1) // Shopify should be active
    } else {
      setActive(1) // Default to "Knowledge Base"
    }
  }, [chatbot, setActive])

  useEffect(() => {
    const fetchData = async () => {
      const data = new GetDataSet()
      try {
        // const counts = await data.GetCount();
        // console.log("Counts:", counts[0].count);
        // setCounts({
        //     chatbot: counts[0].count || 0,
        //     article: counts[1].count || 0,
        //     faq:counts[2].count || 0,
        //     unmatched: counts[3].count || 0
        // });
      } catch (error) {
        console.error('Error fetching category counts:', error)
      }
    }

    fetchData()
    // Event listener for the custom "datasetDeleted" event
    const handleDatasetDeleted = event => {
      if (event.detail === true) {
        fetchData()
      }
    }

    // Add event listener
    window.addEventListener('datasetDeleted', handleDatasetDeleted)

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('datasetDeleted', handleDatasetDeleted)
    }
  }, []) // Only runs once when the component mounts
  // console.log("Counts:", Counts);

  useEffect(() => {}, [])

  const handleTogglePreview = () => {
    if (!previewActive) {
      window.dispatchEvent(new CustomEvent('triggerpreview', { detail: true }))
    } else {
      window.dispatchEvent(new CustomEvent('removepreview', { detail: false }))
    }
    setPreviewActive(!previewActive)
  }

  return (
    <div className='w-full md:w-[190px] pt-10 px-3'>
      <div className='flex items-center gap-1'>
        <h1 className='font-extrabold text-[23px] ml-2 leading-[48px]'>
          Training
        </h1>
        <InfoIconWithToolTip content='Empower your bot with the right knowledge. Add FAQs, documents, and custom data to ensure accurate, context-aware responses tailored to your business needs.' />
      </div>

      <div className='block mt-4 md:mt-5'>
        <div className='flex flex-row md:flex-col gap-2 md:gap-3 overflow-x-auto scrollbar-hide'>
          {/* Shopify/Website/Magento */}
          <div
            onClick={() => handleItemClick(1)}
            className={`cursor-pointer flex justify-between pt-2 pb-2 pl-3 pr-3 rounded-lg ${
              active === 1 ? 'active-item' : ''
            }`}
          >
            <p className='font-[500] text-[14px] leading-[24px] whitespace-nowrap'>
              {chatbot === 'shopify'
                ? 'Shopify'
                : chatbot === 'website'
                ? 'Website'
                : chatbot === 'magento' && 'Magento'}
            </p>
          </div>

          {/* Knowledge Base */}
          <div
            onClick={() => handleItemClick(2)}
            className={`cursor-pointer flex justify-between items-center pt-2 pb-2 px-3 rounded-lg ${
              active === 2 ? 'active-item' : ''
            }`}
          >
            <p className='font-[500] text-[14px] leading-[24px] whitespace-nowrap'>
              Knowledge Base
            </p>
            {isAccessRestricted && (
              <IonIcon name='lock-closed-outline' className='text-[#7C50DD]' />
            )}
          </div>

          {/* FAQs */}
          {/* <div
            onClick={() => handleItemClick(3)}
            className={`cursor-pointer flex justify-between items-center pt-2 pb-2 px-3 rounded-lg ${
              active === 3 ? 'active-item' : ''
            }`}
          >
            <p className='font-[500] text-[14px] leading-[24px] whitespace-nowrap'>
              FAQs
            </p>
            {isAccessRestricted && (
              <IonIcon name='lock-closed-outline' className='text-[#7C50DD]' />
            )}
          </div> */}

          {/* Unanswered */}
          <div
            onClick={() => handleItemClick(4)}
            className={`cursor-pointer flex justify-between items-center pt-2 pb-2 px-3 rounded-lg ${
              active === 4 ? 'active-item' : ''
            }`}
          >
            <p className='font-[500] text-[14px] leading-[24px] whitespace-nowrap'>
              Unanswered
            </p>
            {isAccessRestricted && (
              <IonIcon name='lock-closed-outline' className='text-[#7C50DD]' />
            )}
          </div>

          {/* Preview Toggle */}
          <div
            onClick={handleTogglePreview}
            data-tooltip-id='my-tooltip'
            data-tooltip-content={
              previewActive
                ? 'Click to close the chatbot preview.'
                : 'Click to preview how the chatbot will appear to users.'
            }
            data-tooltip-place='top'
            data-tooltip-class-name='tooltip-hover'
            className={`text-white flex items-center mt-2 gap-2 pt-2 pb-2 px-3 rounded-full ${
              previewActive
                ? 'bg-red-600 closepreview'
                : 'bg-[#232328] showpreview'
            }`}
          >
            <IonIcon name={previewActive ? 'eye-off-outline' : 'eye-outline'} />
            <p className='font-[500] text-[14px] leading-[24px] cursor-pointer whitespace-nowrap'>
              {previewActive ? 'Close Preview' : 'Preview Chatbot'}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
